import { jsx as _jsx } from "react/jsx-runtime";
import { FactSlogan } from '@coolblue-development/freddy';
import { FactContainer } from '../ImageEntrances.styled.js';
export const FactSloganElement = ({ fact, slogan, size }) => (_jsx(FactContainer, { children: _jsx(FactSlogan, { fact: fact, slogan: slogan, size: size, variant: "inverse" }) }));
//# sourceMappingURL=FactSloganElement.js.map